import { gql } from 'graphql-tag'

export const allAnnualReportQuery = gql`
  query allAnnualReport($where: AnnualReportFilter!) {
    allAnnualReport(where: $where, sort: [{ _updatedAt: DESC }], limit: 1) {
      _id
      name
      annualReportSections {
        ... on AnnualReportSection {
          __typename
          _key
          visibleInMenu
          menuTitle {
            de
            fr
            it
            en
          }
          menuSlug {
            current
          }
          annualReportBlock {
            __typename

            ... on AnnualReportAnimation {
              _id
              title {
                de
                fr
                it
                en
              }
              animationFile {
                de {
                  asset {
                    url
                  }
                }
                fr {
                  asset {
                    url
                  }
                }
                it {
                  asset {
                    url
                  }
                }
                en {
                  asset {
                    url
                  }
                }
              }
              animationFileMobile {
                de {
                  asset {
                    url
                  }
                }
                fr {
                  asset {
                    url
                  }
                }
                it {
                  asset {
                    url
                  }
                }
                en {
                  asset {
                    url
                  }
                }
              }
              animationPreview {
                asset {
                  url
                }
              }
            }
            ... on AnnualReportTitle {
              _id
              title {
                de
                fr
                it
                en
              }
              subtitle {
                de
                fr
                it
                en
              }
              imageCredit {
                de
                fr
                it
                en
              }
              imageDescription {
                de
                fr
                it
                en
              }
              image {
                _key
                asset {
                  url
                  altText
                  size
                  metadata {
                    lqip
                    dimensions {
                      height
                      width
                    }
                  }
                }
                hotspot {
                  x
                  y
                }
              }
            }
            ... on AnnualReportContent {
              _id
              title {
                de
                fr
                it
                en
              }
              content {
                de
                fr
                it
                en
              }
              colorlist
              videos {
                videoId {
                  de
                  fr
                  it
                  en
                }
                title {
                  de
                  fr
                  it
                  en
                }
              }
            }
            ... on AnnualReportStory {
              _id
              colorlist
              layout
              storyLink {
                _id
                title {
                  de
                  fr
                  it
                  en
                }
                subtitle {
                  de
                  fr
                  it
                  en
                }
                excerpt {
                  de
                  fr
                  it
                  en
                }
                intro {
                  de
                  fr
                  it
                  en
                }
                richTextSections {
                  deRaw
                  frRaw
                  enRaw
                  itRaw
                }
                image {
                  _key
                  asset {
                    url
                    altText
                    size
                    metadata {
                      lqip
                      dimensions {
                        height
                        width
                      }
                    }
                  }
                }
              }
            }
            ... on AnnualReportStatistic {
              _id
              year
              title {
                de
                fr
                it
                en
              }
            }
            ... on AnnualReportIntro {
              _id
              title {
                de
                fr
                it
                en
              }
              subtitle {
                de
                fr
                it
                en
              }
              imageCredit {
                de
                fr
                it
                en
              }
              imageDescription {
                de
                fr
                it
                en
              }
              image {
                _key
                asset {
                  url
                  altText
                  size
                  metadata {
                    lqip
                    dimensions {
                      height
                      width
                    }
                  }
                }
                hotspot {
                  x
                  y
                }
              }
              halfWidth
              headingSize
              colorlist
            }
            ... on AnnualReportCenteredText {
              _id
              title {
                de
                fr
                it
                en
              }
              text {
                de
                fr
                it
                en
              }
              colorlist
            }
            ... on AnnualReportRevenue {
              _id
              title {
                de
                fr
                it
                en
              }
              total {
                de
                fr
                it
                en
              }
              lastYears
            }
            ... on AnnualReportSlideshow {
              _id
              interval
              animationHandler
              slides {
                title {
                  de
                  fr
                  it
                  en
                }
                color
                image {
                  _key
                  de {
                    asset {
                      url
                      altText
                      metadata {
                        lqip
                        dimensions {
                          width
                          height
                        }
                      }
                    }
                    hotspot {
                      x
                      y
                    }
                  }
                  en {
                    asset {
                      url
                      altText
                      metadata {
                        lqip
                        dimensions {
                          width
                          height
                        }
                      }
                    }
                    hotspot {
                      x
                      y
                    }
                  }
                  it {
                    asset {
                      url
                      altText
                      metadata {
                        lqip
                        dimensions {
                          width
                          height
                        }
                      }
                    }
                    hotspot {
                      x
                      y
                    }
                  }
                  fr {
                    asset {
                      url
                      altText
                      metadata {
                        lqip
                        dimensions {
                          width
                          height
                        }
                      }
                    }
                    hotspot {
                      x
                      y
                    }
                  }
                }
              }
            }
            ... on AnnualReportMilestones {
              title {
                de
                fr
                en
                it
              }
              subtitle {
                de
                fr
                en
                it
              }
              targetYear
              milestones {
                ... on AnnualReportMilestone {
                  title {
                    de
                    fr
                    en
                    it
                  }
                  subtitle {
                    de
                    fr
                    en
                    it
                  }
                  image {
                    _key
                    asset {
                      url
                      altText
                      size
                      metadata {
                        lqip
                        dimensions {
                          height
                          width
                        }
                      }
                    }
                    hotspot {
                      x
                      y
                    }
                  }
                  year {
                    de
                    fr
                    en
                    it
                  }
                }
              }
            }
            ... on AnnualReportIconContent {
              _id
              title {
                de
                fr
                it
                en
              }
              subtitle {
                de
                fr
                it
                en
              }
              content {
                de
                fr
                it
                en
              }
              icons {
                ... on AnnualReportIconWithTitle {
                  _key
                  title {
                    de
                    fr
                    it
                    en
                  }
                  subtitle {
                    de
                    fr
                    it
                    en
                  }
                  image {
                    _key
                    asset {
                      url
                      altText
                      metadata {
                        lqip
                      }
                    }
                  }
                }
              }
            }
            ... on AnnualReportTextAndImage {
              _id
              title {
                de
                en
                fr
                it
              }
              showQuotes
              subtitle {
                de
                en
                fr
                it
              }
              content {
                deRaw
                frRaw
                enRaw
                itRaw
              }
              image {
                _key
                asset {
                  url
                  altText
                  metadata {
                    lqip
                  }
                }
                hotspot {
                  x
                  y
                }
              }
              colorlist
              forcePrimaryThemeColor
            }
            ... on AnnualReportFacts {
              title {
                de
                fr
                en
                it
              }
              facts {
                ... on AnnualReportFact {
                  fact {
                    de
                    fr
                    en
                    it
                  }
                  description {
                    de
                    fr
                    en
                    it
                  }
                  textSize
                }
              }
            }
            ... on AnnualReportContentWithLinks {
              title {
                de
                fr
                en
                it
              }
              projectLinks {
                ... on AnnualReportProjectLink {
                  _key
                  title {
                    de
                    fr
                    en
                    it
                  }
                  subtitle {
                    de
                    fr
                    en
                    it
                  }
                  link {
                    pageSlug {
                      current
                    }
                    year
                  }
                  image {
                    _key
                    asset {
                      url
                      altText
                      metadata {
                        lqip
                        dimensions {
                          height
                          width
                        }
                      }
                    }
                    hotspot {
                      x
                      y
                    }
                  }
                }
              }
            }
            ... on AnnualReportContentWithImage {
              _id
              title {
                de
                fr
                it
                en
              }
              content {
                de
                fr
                it
                en
              }
              imageDesktop {
                _key
                de {
                  asset {
                    url
                    altText
                    metadata {
                      lqip
                      dimensions {
                        width
                        height
                      }
                    }
                  }
                  hotspot {
                    x
                  }
                }
                en {
                  asset {
                    url
                    altText
                    metadata {
                      lqip
                      dimensions {
                        width
                        height
                      }
                    }
                  }
                  hotspot {
                    x
                  }
                }
                it {
                  asset {
                    url
                    altText
                    metadata {
                      lqip
                      dimensions {
                        width
                        height
                      }
                    }
                  }
                  hotspot {
                    x
                  }
                }
                fr {
                  asset {
                    url
                    altText
                    metadata {
                      lqip
                      dimensions {
                        width
                        height
                      }
                    }
                  }
                  hotspot {
                    x
                    y
                  }
                }
              }
              imageMobile {
                _key
                de {
                  asset {
                    url
                    altText
                    metadata {
                      lqip
                      dimensions {
                        width
                        height
                      }
                    }
                  }
                  hotspot {
                    x
                    y
                  }
                }
                en {
                  asset {
                    url
                    altText
                    metadata {
                      lqip
                      dimensions {
                        width
                        height
                      }
                    }
                  }
                  hotspot {
                    x
                    y
                  }
                }
                it {
                  asset {
                    url
                    altText
                    metadata {
                      lqip
                      dimensions {
                        width
                        height
                      }
                    }
                  }
                  hotspot {
                    x
                    y
                  }
                }
                fr {
                  asset {
                    url
                    altText
                    metadata {
                      lqip
                      dimensions {
                        width
                        height
                      }
                    }
                  }
                  hotspot {
                    x
                    y
                  }
                }
              }
              colorlist
            }
            ... on AnnualReportProjectNetwork {
              _id
              _key

              title {
                de
                en
                it
                fr
              }
              headline {
                de
                en
                it
                fr
              }
              content {
                deRaw
                enRaw
                itRaw
                frRaw
              }
              image {
                asset {
                  url
                  altText
                  metadata {
                    lqip
                  }
                }
                hotspot {
                  x
                  y
                }
              }
              networkImage {
                de {
                  asset {
                    url
                    altText
                    metadata {
                      lqip
                      dimensions {
                        aspectRatio
                        width
                        height
                      }
                    }
                  }
                  hotspot {
                    x
                    y
                  }
                }
                en {
                  asset {
                    url
                    altText
                    metadata {
                      lqip
                      dimensions {
                        aspectRatio
                        width
                        height
                      }
                    }
                  }
                  hotspot {
                    x
                    y
                  }
                }
                it {
                  asset {
                    url
                    altText
                    metadata {
                      lqip
                      dimensions {
                        aspectRatio
                        width
                        height
                      }
                    }
                  }
                  hotspot {
                    x
                    y
                  }
                }
                fr {
                  asset {
                    url
                    altText
                    metadata {
                      lqip
                      dimensions {
                        aspectRatio
                        width
                        height
                      }
                    }
                  }
                  hotspot {
                    x
                    y
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`

export const sanityImageAssetQuery = gql`
  query sanityImageAsset($id: ID!) {
    SanityImageAsset(id: $id) {
      _id
      url
      altText
      size
      extension
      metadata {
        lqip
        dimensions {
          height
          width
        }
      }
    }
  }
`

export const allAnnualReportYearsQuery = gql`
  query allAnnualReportYears($where: AnnualReportFilter!) {
    allAnnualReport(where: $where, sort: [{ _updatedAt: DESC }]) {
      _id
      name
    }
  }
`

export const allAnnualReportPages = gql`
  query allAnnualReportPages($where: AnnualReportPageFilter!) {
    allAnnualReportPage(where: $where, sort: [{ sorting: ASC }]) {
      _id
      __typename
      pageSlug {
        current
      }
      menuTitle {
        de
        fr
        it
        en
      }
    }
  }
`

export const annualReportPageById = gql`
  query annualReportPageByKey($id: ID!) {
    AnnualReportPage(id: $id) {
      year
      pageSlug {
        current
      }
    }
  }
`
